/**
 * "Kế hoạch sử dụng đất" view: the land-use plan maps (KHSDĐ cấp huyện by year, QHSDĐ đến 2020)
 * of the Department of Agriculture and Environment, shown as raster tiles through /api/sdd
 * (one source per former district, PlanMap._swapRaster). Catalogue: public/data/khsdd.json.
 * Raster only: the department publishes no open point query, so the map colours / codes are
 * read against the official legend image.
 */
import { bus, prefs, savePrefs, writeHash } from './state.js';
import { vurl } from './assetv.js';

export const SDD = 'sdd';
let catalog = null, loading = null, pm = null;

export const sddCatalog = () => catalog;

export function loadSddCatalog() {
  if (catalog) return Promise.resolve(catalog);
  loading ||= fetch(vurl('/data/khsdd.json', 'khsdd'))
    .then((r) => { if (!r.ok) throw new Error('khsdd ' + r.status); return r.json(); })
    .then((c) => { catalog = c; bus.emit('sdd-catalog', c); return c; })
    .catch((e) => { loading = null; throw e; });
  return loading;
}

/** Current period object (the department's default when none / unknown is chosen). */
export function sddPeriod() {
  if (!catalog) return null;
  const ps = catalog.periods || [];
  return ps.find((p) => p.id === prefs.sddPeriod) || ps.find((p) => p.isDefault) || ps[0] || null;
}

export function setSddPeriod(id) {
  if (!catalog?.periods.some((p) => p.id === id)) return;
  const def = (catalog.periods.find((p) => p.isDefault) || catalog.periods[0]).id;
  prefs.sddPeriod = id === def ? null : id;
  savePrefs();
  writeHash({});
  pm?.setSdd(sddPeriod());
  bus.emit('sdd-period', id);
}

/** District maps of the period whose bounds contain the point (bounds overlap at district edges). */
export function sddLayersAt(lat, lng, period = sddPeriod()) {
  if (!period) return [];
  return period.layers.filter(([, , b]) => lng >= b[0] && lng <= b[2] && lat >= b[1] && lat <= b[3]);
}

function sync() {
  if (prefs.plan !== SDD) return;
  loadSddCatalog().then(() => pm.setSdd(sddPeriod())).catch(() => {});
}

export function initSdd(planMap) {
  pm = planMap;
  bus.on('plan', sync);
  sync();
}
